import React, { Component } from "react";
import { kFormatter } from "../../../../../../../../utils";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers";
class LeaderBoardFrame extends Component {

    render() {
        const { rows, theme, topUsers, apiStatus,leader }= this.props
        return ( <div className="ts_board_users ts_editor_window" data-theme={theme == 1 ? 'dark' : 'light'}>
               
                { topUsers ? 
                 apiStatus == 'success' && topUsers.length ?
                 <div className="ts_user_wrapper">
                    <div className="ts_board_title">Top {leader == 1 ? `Most Popular Influencers` : `Most Active Users`}</div>
                    <div className={`ts_user_list_wrapper ts_users_top_${rows} ts_user_count_${rows}`}>
                         <div className="ts_top_users">
                            {topUsers && topUsers.map((user, index) => {
                                let picture = user.image;
                                return(
                                    <div className={`ts_user_list ts_user__${index+1}`}>
                                        <div className="ts_author_wrapper">
                                            <div className="ts_author_count_wrapper">
                                                <div className="tb_author_count">{index + 1}</div>
                                            </div>
                                            <div className="ts_author_wrap_in">
                                                <div className="ts_author_profile">
                                                    <img src={user.image} onError={event => event.target.src = user.author.errorPic} />
                                                    <div className="ts_author_social_">
                                                        <div className={`ts_social_ico tb__icon ${user.network.icon}`}> </div>
                                                    </div>
                                                </div>
                                                <div className="ts_author_info_wrapper">
                                                    <div className="ts_author_info">
                                                        <div className="ts_authorname">{user.author.name}</div>
                                                        <div className="ts_username">{user.author.username}</div>
                                                    </div>
                                                    <div className="ts_followers_count">{leader == 2 ? kFormatter(user.postCount) :kFormatter(user.author.follower)} {leader == 2 ? user.postCount > 1 ? 'Posts' : 'Post' :user.author.follower > 1 ? 'Followers' : 'Follower'}</div>
                                                </div>
                                                <div className="ts_author_social_right">
                                                    <div className={`ts_social_ico tb__icon ${user.network.icon}`}> </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                       
                    </div>
                </div>
                :
                apiStatus == 'success' && topUsers.length == 0 ?
                <div className="ts_user_wrapper">
                    <div className="ts_no_users">
                        <img className="ts_no_users_img" src={toAbsoluteUrl("/css/leaderboard/user-profile.svg")} alt={'no users'} />
                        <div className="ts_no_user_title">
                            No Entry Found Yet
                        </div>
                    </div>
                </div> : null : null}

            </div>);
    }
}



export default LeaderBoardFrame;